import uuid4 from '../../../node_modules/@buzzfeed/bf-utils/lib/uuid4/index.js';

/**
 * These properties are kept separate from the main commonClientMetadata because
 * commonClientMetadata is memoized. These values need to be unique and recalculated for every new
 * event.
 * @return {Object}
 */
var commonClientMetadataEvent = (_ref => {
  let {
    url
  } = _ref;
  return () => ({
    event_uri: url,
    event_ts: Math.round(Date.now() / 1000),
    event_uuid: uuid4()
  });
});

export default commonClientMetadataEvent;
